import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, paragraphMedium } from '@helpers/typography';
import FieldSharedStyles from '@stories/Components/FormFields/FieldShared.styles';
import TextboxStyles from '@stories/Components/Inputs/Textbox/Textbox.styles';
import AccordionStyles from '@stories/Components/Misc/Accordion/Accordion.styles';
import ErrorAreaStyles from '@stories/Components/Misc/ErrorArea/ErrorArea.styles';
import styled from 'styled-components';
const Container = styled.section `
  position: relative;
  background-color: var(--accountWidgetBg);
  color: var(--accountFgColour);
`;
const Content = styled.div `
  ${contentStyles};

  p {
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(26, 28)};
  }

  a {
    color: var(--accountHighlightColour);
  }
`;
const Form = styled.form `
  position: relative;
  background-color: var(--accountFormBgColour);
  color: var(--accountFormFgColour);
  padding: ${fluid(16, 32)} ${fluid(16, 32)} ${fluid(18, 72)};
  border-radius: ${fluid(5, 10)};

  ${ErrorAreaStyles.ErrorArea} {
    grid-column: 1 / span 12;
  }
`;
const FormSection = styled.fieldset `
  display: grid;
  width: 100%;
  gap: 28px var(--gutterWidth);
  padding: 0 0 ${fluid(28, 32)};

  &:not(:last-of-type) {
    border-bottom: 1px solid ${brand.primary.blueGrey};
    margin: 0 0 ${fluid(28, 32)};
  }

  &:last-of-type {
    margin: 0 0 ${fluid(24, 48)};
  }

  ${FieldSharedStyles.Container} {
    grid-column: span 1;
    margin: 0;
  }

  ${TextboxStyles.Input} {
    ${transition('border-color')};

    border-color: ${brand.secondary.blueGrey};
    border-width: 2px;
    background-color: var(--accountFormBgColour);
    color: var(--accountFormFgColour);

    &:focus-visible {
      border-color: ${brand.secondary.blueGreyFaded};
    }
  }

  ${TextboxStyles.Input} {
    border-radius: 100px;
  }

  ${AccordionStyles.Item} {
    --padding: ${fluid(12, 16)};

    background-color: var(--accountFormInnerBgColour);
    color: var(--accountFormFgColour);
    border: 0;
    padding: var(--padding);
    border-radius: ${fluid(5, 10)};
  }

  ${AccordionStyles.ItemHeader} {
    padding: 0;
  }

  ${AccordionStyles.ItemTitle} {
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(26, 28)};
    margin: 0;
  }

  ${AccordionStyles.ItemBodyContent} {
    padding: var(--padding) 0 0;

    ul li {
      font-size: ${fluid(14, 16)};
      line-height: ${fluid(22, 24)};
    }

    ul li:not(:last-child) {
      margin-bottom: ${fluid(8, 12)};
    }
  }

  @media ${until(Device.Tablet)} {
    ${AccordionStyles.Container} {
      grid-row: 4;
    }
  }

  @media ${from(Device.Tablet)} {
    row-gap: 24px;
    grid-template-columns: repeat(3, 1fr);

    ${AccordionStyles.Container} {
      grid-column: span 2;
    }
  }
`;
const LineBreak = styled.div `
  display: none;

  @media ${from(Device.DesktopLarge)} {
    display: block;
    grid-column: span 1;
  }

  &[data-double] {
    @media ${from(Device.Tablet)} {
      display: block;
      grid-column: span 1;
    }

    @media ${from(Device.DesktopLarge)} {
      grid-column: span 2;
    }
  }
`;
const Confirmation = styled.p `
  ${paragraphMedium};

  position: relative;
`;
const ChangePasswordStyles = {
    Container,
    Content,
    Form,
    FormSection,
    LineBreak,
    Confirmation,
};
export default ChangePasswordStyles;
